import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './index.css';
import 'leaflet/dist/leaflet.css';
import './styles/map.css';
import { setupDevErrorHandlers } from './utils/dev-error-handler';
import { initSentry } from './utils/sentry';
import { startConsentBridge } from './utils/consentBridge';

// Essential monitoring (no consent required)
initSentry();

// Analytics and performance only after Axeptio consent
startConsentBridge();

// Set up development error handlers
if (import.meta.env.DEV) {
  setupDevErrorHandlers();
}

// Create root element if it doesn't exist
const rootElement = document.getElementById('root') || document.createElement('div');
if (!rootElement.id) {
  rootElement.id = 'root';
  document.body.appendChild(rootElement);
}

createRoot(rootElement).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Remove loading overlay once React has painted its first frame.
// requestAnimationFrame ensures the overlay only disappears after React
// has at least started rendering — preventing any flash of static HTML.
requestAnimationFrame(() => {
  const loader = document.getElementById('fb-loader');
  if (loader) {
    loader.classList.add('fb-loader--done');
    loader.addEventListener('animationend', () => loader.remove(), { once: true });
  }
});